module.exports = __webpack_public_path__ + "static/messages_hazena-2efdb11c8cd264612e34bfb3340e32c1.mp4";